// extracted by mini-css-extract-plugin
export default {"stripe-container":"stripe_stripe-container__fsIvm","stripe-btn-container":"stripe_stripe-btn-container__wCvU8","btn":"stripe_btn__kOJaO"};